import { render, staticRenderFns } from "./VerLiquidacion.vue?vue&type=template&id=46e74ae2&"
import script from "./VerLiquidacion.vue?vue&type=script&lang=js&"
export * from "./VerLiquidacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports